import React, { useContext } from "react";
import products from "../data/products";
import ProductCard from "../components/ProductCard";
import { SearchContext } from "../context/SearchContext";
import { CartContext } from "../context/CartContext";
import "./Home.css";
import heroImg from "../assets/banner3.jpg";

const Home = () => {
  const { search } = useContext(SearchContext);
  const { addToCart, addToWishlist } = useContext(CartContext);

  const filteredProducts = products.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  const isSearching = search.trim() !== "";

  return (
    <div className="home">

      {/* HERO */}
      <div className="hero">
        <img src={heroImg} alt="banner" />
        <div className="hero-overlay">
          <h1>Elegant Handmade Bags</h1>
          <p>Crafted with love & tradition</p>
          <button>Shop Now</button>
        </div>
      </div>

      {/* SEARCH RESULTS */}
      {isSearching && (
        <>
          <h2 className="title">Search Results</h2>

          <div className="product-grid">
            {filteredProducts.length > 0 ? (
              filteredProducts.map((item) => (
                <ProductCard
                  key={item.id}
                  product={item}
                  addToCart={addToCart}
                  addToWishlist={addToWishlist}
                />
              ))
            ) : (
              <h3>No products found 😢</h3>
            )}
          </div>
        </>
      )}

      {/* ALL PRODUCTS */}
      {!isSearching && (
        <>
          <h2 className="title">Our Handmade Collection</h2>

          <div className="product-grid">
            {products.map((item) => (
              <ProductCard
                key={item.id}
                product={item}
                addToCart={addToCart}
                addToWishlist={addToWishlist}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Home;